import React from "react";
import "./Business.css";

const Business = () => {
  return (
    <div className="business-container">
      <h2>Business Solutions</h2>
      <p>
        As a freelancer, I build basic websites for companies with modern design
        and AI features:
      </p>
      <ul>
        <li>Landing Pages with responsive design</li>
        <li>E-commerce product showcase</li>
        <li>Portfolio websites for professionals</li>
        <li>AI-powered contact forms and analytics</li>
      </ul>
      <p>
        These solutions help businesses stand out online while keeping things
        simple and effective.
      </p>
    </div>
  );
};

export default Business;
